import { IState, REDUX_PROP } from './reducer';

export const getState: (s: any) => IState = s => s[ REDUX_PROP ];
